
function Blog() {
    return(
        <div>
            <h1>My Stories</h1>
        </div>
    );
}

export default Blog